import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lift-user',
  templateUrl: './lift-user.component.html',
  styleUrls: ['./lift-user.component.css']
})
export class LiftUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
